import { render } from "./recently.vue?vue&type=template&id=2bd60e67"
import script from "./recently.vue?vue&type=script&lang=js"
export * from "./recently.vue?vue&type=script&lang=js"

import "./recently.vue?vue&type=style&index=0&id=2bd60e67&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__